import { render, staticRenderFns } from "./BarChartWidget.vue?vue&type=template&id=60a53a44&scoped=true"
import script from "./BarChartWidget.vue?vue&type=script&lang=js"
export * from "./BarChartWidget.vue?vue&type=script&lang=js"
import style0 from "./BarChartWidget.vue?vue&type=style&index=0&id=60a53a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a53a44",
  null
  
)

export default component.exports